import { faStar } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';

import { useTypedParams } from '@sorare/routing';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { IconButton } from '@sorare/core/src/atoms/buttons/IconButton';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Tooltip } from '@sorare/core/src/atoms/tooltip/Tooltip';
import { MLB_ALL_STAR_COLLECTION_EVENT } from '@sorare/core/src/constants/__generated__/routes';

import { CollectionLayout } from '@sorare/gameplay/src/components/collections/CollectionLayout';

import { POSTSEASON_THRESHOLDS as THRESHOLDS } from 'components/collections/CollectionEvent/CollectionEventProgress';

import { LayoutParams } from './__generated__/routeParams';

const MLBCollectionLayout = () => {
  const { slug, collectionSlug } = useTypedParams<LayoutParams>();
  return (
    <CollectionLayout
      collection={collectionSlug}
      slug={slug}
      renderCollectionEventStep={(
        rarity:
          | Rarity.limited
          | Rarity.rare
          | Rarity.super_rare
          | Rarity.unique,
        score: number
      ) =>
        THRESHOLDS[rarity]
          ? {
              value: THRESHOLDS[rarity],
              bonus: (
                <Tooltip
                  title={
                    <FormattedMessage
                      id="Baseball.CollectionEvent.plusOneEntry"
                      defaultMessage="+1 Collection Event Entry"
                    />
                  }
                >
                  <IconButton
                    to={MLB_ALL_STAR_COLLECTION_EVENT}
                    color="transparent"
                    smaller
                  >
                    <FontAwesomeIcon
                      icon={faStar}
                      color={
                        score >= THRESHOLDS[rarity]
                          ? 'var(--c-yellow-600)'
                          : 'rgba(var(--c-rgb-yellow-600), 0.5)'
                      }
                    />
                  </IconButton>
                </Tooltip>
              ),
            }
          : null
      }
    />
  );
};

export default MLBCollectionLayout;
